@if (initialized$ | async) {
	<form [formGroup]="form">
		@for (facet of allFacets; track facet) {
			<div class="c-filter-buttons-bar__facet">
				<h2 class="c-vloket-header c-vloket-header--h4 u-margin-bottom-lg">
					<span class="c-vloket-text-marking c-vloket-text-marking--underline">
						{{ facet.name }}
					</span>
				</h2>
				<ul class="c-filter-buttons-bar__facet__list" [formGroupName]="facet.id">
					@for (item of facet.items; track item) {
						<li class="c-filter-buttons-bar__facet__list__item">
							<cjm-check-button
								[formControlName]="item.id"
								[id]="item.id"
								[title]="item.name"
								[withIcon]="true"
							>
								<vloket-advice-page-theme-tag [tagId]="item.id" />
								<p>
									{{ item.name }}
								</p>
							</cjm-check-button>
						</li>
					}
					@if (facet?.items?.length === 0) {
						<li class="c-filter-buttons-bar__facet__list__fallback">
							{{ i18nKeys.FilterBar.Facets.NoResults | translate }}
						</li>
					}
				</ul>
			</div>
		}
	</form>
}
